/* Cerrojo de scroll compartido por el menu, el cajon de cesta y el pop-up.
   Cada uno tocaba document.body.style.overflow por su cuenta: cerrar uno
   desbloqueaba la pagina con otro todavia abierto, y en movil eso se ve como
   que la web se ha colgado. Aqui manda el conjunto, no el ultimo que cierra. */
window.fvCerrojo = (function () {
  var abiertos = {};
  return function (nombre, v) {
    abiertos[nombre] = v;
    var alguno = Object.keys(abiertos).some(function (k) { return abiertos[k]; });
    document.body.style.overflow = alguno ? 'hidden' : '';
  };
})();

/* FERVANTE — JS minimo. Sin dependencias. Todo pasivo y diferido. */
(function () {
  'use strict';

  /* ---- aparicion progresiva -------------------------------------------- */
  document.documentElement.classList.add('fv-listo');   // el seguro del <head> ya puede confiar

  var rev = document.querySelectorAll('.fv-rev');
  /* Lo que ya entra en pantalla al cargar se muestra sin animacion: si no, la
     portada y la cabecera de coleccion aparecen en blanco tres cuartos de
     segundo y la web se siente lenta aunque haya cargado. */
  rev.forEach(function (el) {
    if (el.getBoundingClientRect().top < window.innerHeight * 0.95) {
      el.classList.add('is-in', 'sin-anim');
    }
  });
  rev = document.querySelectorAll('.fv-rev:not(.is-in)');
  if (rev.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    rev.forEach(function (el) { io.observe(el); });
  } else {
    rev.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Ultima red: si a los 4 s queda algo sin revelar (ventana de altura 0,
     pestana en segundo plano, observador que no dispara), se enseña. Mas vale
     perder una animacion que esconder el contenido. */
  setTimeout(function () {
    document.querySelectorAll('.fv-rev:not(.is-in)').forEach(function (el) {
      el.classList.add('is-in', 'sin-anim');
    });
  }, 4000);

  /* ---- cabecera que se esconde al bajar --------------------------------- */
  var head = document.querySelector('.fv-head');
  if (head) {
    var ultimo = 0, tic = false;
    window.addEventListener('scroll', function () {
      if (tic) return;
      tic = true;
      window.requestAnimationFrame(function () {
        var y = window.pageYOffset;
        if (y > ultimo && y > 320) head.classList.add('is-oculta');
        else head.classList.remove('is-oculta');
        ultimo = y;
        tic = false;
      });
    }, { passive: true });
  }

  /* ---- menu movil y cajon de cesta --------------------------------------
     Nada de guardarse los nodos: al anadir al carrito se reemplaza el HTML de
     la seccion de cesta entera, asi que cualquier referencia guardada apunta a
     un nodo ya desconectado. El boton de cerrar y el velo dejaban de funcionar
     y el body se quedaba con overflow:hidden: la pagina congelada, sobre todo
     en movil. Se consulta el DOM en cada llamada y se delegan los clics.
     El bloqueo del scroll se lleva por estado, no por quien cierra ultimo.   */
  function menuAbrir(v) {
    var m = document.querySelector('.fv-menu');
    if (!m) return;
    m.classList.toggle('is-abierto', v);
    window.fvCerrojo('menu', v);
  }

  /* ---- filtros del catalogo --------------------------------------------- */
  var filtros = document.querySelectorAll('[data-fv-filtro]');
  filtros.forEach(function (b) {
    b.addEventListener('click', function () {
      var cat = b.getAttribute('data-fv-filtro');
      filtros.forEach(function (o) { o.classList.toggle('is-activo', o === b); });
      document.querySelectorAll('[data-fv-cat]').forEach(function (c) {
        c.classList.toggle('is-fuera', cat !== 'todo' && c.getAttribute('data-fv-cat') !== cat);
      });
    });
  });

  /* ---- selector de talla/color en la ficha ------------------------------ */
  document.querySelectorAll('[data-fv-opciones]').forEach(function (grupo) {
    grupo.addEventListener('change', function (ev) {
      if (!ev.target.matches('input[type=radio]')) return;
      grupo.querySelectorAll('.fv-opt__b').forEach(function (l) {
        l.classList.toggle('is-sel', l.contains(ev.target));
      });
      var salida = grupo.querySelector('[data-fv-opt-valor]');
      if (salida) salida.textContent = ev.target.value;
    });
  });

  function cesta(v) {
    var c = document.querySelector('.fv-cajon');
    if (!c) return;
    c.classList.toggle('is-abierto', v);
    var vel = document.querySelector('.fv-velo');
    if (vel) vel.classList.toggle('is-abierto', v);
    window.fvCerrojo('cesta', v);
  }
  window.fvCesta = cesta;   // lo usa el alta en cesta sin recargar

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fv-cesta-abrir]')) { e.preventDefault(); cesta(true); return; }
    if (e.target.closest('[data-fv-cesta-cerrar]')) { cesta(false); return; }
    if (e.target.closest('[data-fv-menu-abrir]'))  { menuAbrir(true);  return; }
    if (e.target.closest('[data-fv-menu-cerrar]')) { menuAbrir(false); return; }
    if (e.target.closest('.fv-velo')) { cesta(false); menuAbrir(false); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { cesta(false); menuAbrir(false); }
  });
})();

/* ---- selector de variante en la ficha de producto ---------------------- */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-fv-producto]');
  if (!raiz) return;
  var datos = raiz.querySelector('[data-fv-variantes]');
  if (!datos) return;

  var variantes;
  try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }

  var campoId = raiz.querySelector('[data-fv-variante-id]');
  var precio  = raiz.querySelector('[data-fv-precio]');
  var antes   = raiz.querySelector('[data-fv-antes]');
  var boton   = raiz.querySelector('[data-fv-anadir]');
  var botonTx = raiz.querySelector('[data-fv-anadir-txt]');
  var grupos  = raiz.querySelectorAll('[data-fv-opciones]');
  if (!grupos.length) return;

  function dinero(centimos) {
    // Mismo formato que pinta Liquid en la tienda: simbolo delante y coma.
    return '\u20ac' + (centimos / 100).toLocaleString('es-ES', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  function seleccion() {
    // Por indice REAL de la opcion (data-fv-indice), no por orden del DOM:
    // el color se pinta primero aunque en Shopify sea la segunda opcion.
    var sel = [];
    Array.prototype.forEach.call(grupos, function (g) {
      var m = g.querySelector('input[type=radio]:checked');
      sel[parseInt(g.getAttribute('data-fv-indice'), 10) || 0] = m ? m.value : null;
    });
    return sel;
  }

  function actualizar() {
    var sel = seleccion();
    var v = variantes.find(function (x) {
      return sel.every(function (val, i) { return val === null || x.options[i] === val; });
    });
    if (!v) return;

    if (campoId) campoId.value = v.id;
    if (precio) precio.textContent = dinero(v.price);
    if (antes) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        antes.textContent = dinero(v.compare_at_price);
        antes.style.display = '';
      } else { antes.style.display = 'none'; }
    }
    if (boton) {
      boton.disabled = !v.available;
      if (botonTx) botonTx.textContent = v.available ? 'Añadir a la cesta' : 'Agotado';
    }
    if (window.history && window.history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u);
    }
  }

  grupos.forEach(function (g) { g.addEventListener('change', actualizar); });
})();

/* ==========================================================================
   Anadir a la cesta sin recargar la pagina
   El formulario nativo lleva al cliente a /cart y le saca de la ficha. Aqui se
   intercepta, se manda por fetch y se abre el cajon. Si algo falla, se deja
   pasar el envio normal del formulario para no dejar al cliente sin comprar.
   ========================================================================== */
(function () {
  'use strict';
  var form = document.querySelector('form[action$="/cart/add"]');
  if (!form || !window.fetch) return;

  var cajon = document.querySelector('.fv-cajon');
  var velo = document.querySelector('.fv-velo');
  var seccion = document.getElementById('shopify-section-fv-cesta');
  if (!cajon || !seccion) return;

  var boton = form.querySelector('[data-fv-anadir]');
  var textoBoton = form.querySelector('[data-fv-anadir-txt]');

  // el cierre va por delegacion arriba: aqui solo se abre
  function abrir() { if (window.fvCesta) window.fvCesta(true); }

  function actualizarContador(n) {
    var badge = document.querySelector('[data-fv-cesta-n]');
    if (badge) badge.textContent = n;
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (boton) boton.disabled = true;
    if (textoBoton) textoBoton.textContent = 'Añadiendo…';

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        return fetch('?sections=fv-cesta');
      })
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        if (datos['fv-cesta']) {
          seccion.outerHTML = datos['fv-cesta'];
          seccion = document.getElementById('shopify-section-fv-cesta');
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cesta) {
        actualizarContador(cesta.item_count);
        abrir();
      })
      .catch(function () {
        form.submit();          // respaldo: envio clasico
      })
      .then(function () {
        if (boton) boton.disabled = false;
        if (textoBoton) textoBoton.textContent = 'Añadir a la cesta';
      });
  });
})();

/* ---- recomendador de talla ---------------------------------------------
   Matriz tomada de la tabla del fabricante (altura x peso). No extrapolamos
   fuera de sus rangos: si el cliente se sale, le mandamos a preguntar.      */
(function () {
  'use strict';
  var caja = document.querySelector('.fv-tallas');
  if (!caja) return;
  var elAltura = caja.querySelector('[data-fv-altura]');
  var elPeso   = caja.querySelector('[data-fv-peso]');
  var salida   = caja.querySelector('[data-fv-salida]');
  if (!elAltura || !elPeso || !salida) return;

  var ALTURAS = [165, 170, 175, 180, 185, 190];
  var PESOS   = [60, 70, 75, 80, 85, 90, 95, 100];
  var MATRIZ = {
    165: ['S','M','M','L','XL','XL','XXL','XXL'],
    170: ['S','M','M','L','XL','XL','XXL','XXL'],
    175: ['S','M','L','L','XL','XL','XXL','XXL'],
    180: ['M','M','L','L','XL','XL','XXL','XXL'],
    185: ['M','L','L','L','XL','XL','XXL','3XL'],
    190: ['L','L','L','XL','XL','XXL','XXL','3XL']
  };

  function cercano(valor, lista) {
    return lista.reduce(function (a, b) {
      return Math.abs(b - valor) < Math.abs(a - valor) ? b : a;
    });
  }

  function calcular() {
    // los campos van en pulgadas y libras; la tabla del fabricante está en
    // cm y kg, así que se convierte antes de buscar, no al revés
    var inch = parseFloat(elAltura.value);
    var lb   = parseFloat(elPeso.value);
    if (!inch || !lb) { salida.textContent = 'Enter your height and weight.'; return; }
    var h = Math.round(inch * 2.54);
    var p = Math.round(lb * 0.45359);
    if (h < 155 || h > 205 || p < 45 || p > 130) {
      salida.innerHTML = "You're outside the manufacturer's chart. " +
        '<a href="/pages/contacto" style="text-decoration:underline">Write to us</a> and we\'ll tell you the size.';
      return;
    }
    var fila = MATRIZ[cercano(h, ALTURAS)];
    var talla = fila[PESOS.indexOf(cercano(p, PESOS))];
    if (talla === '3XL' || talla === 'XXL') {
      salida.innerHTML = 'You would need a <strong>' + talla + '</strong>, which we don\'t carry. ' +
        '<a href="/pages/contacto" style="text-decoration:underline">Write to us</a> before ordering.';
      return;
    }
    salida.innerHTML = 'Your size is <strong>' + talla + '</strong>.';
    document.querySelectorAll('.fv-opt__b input[type=radio]').forEach(function (r) {
      if (r.value === talla) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  elAltura.addEventListener('input', calcular);
  elPeso.addEventListener('input', calcular);
})();

/* ==========================================================================
   POP-UP DE DESCUENTO
   Se abre a los N segundos o al llegar a cierto scroll, lo que ocurra antes.
   No vuelve a salir si ya se cerró o si ya se dejó el correo.
   ========================================================================== */
(function () {
  'use strict';
  var pop = document.querySelector('[data-fv-pop]');
  if (!pop) return;

  var CLAVE = 'fv-pop-visto';
  function leer(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function guardar(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  var paso  = pop.querySelector('[data-fv-pop-form]');
  var ok    = pop.querySelector('[data-fv-pop-ok]');
  var suscrito = /[?&]customer_posted=true/.test(location.search);

  function abrir() {
    if (!pop.hidden) return;
    pop.hidden = false;
    window.fvCerrojo('pop', true);
  }
  function cerrar() {
    pop.hidden = true;
    window.fvCerrojo('pop', false);
    guardar(CLAVE, '1');
  }

  pop.querySelectorAll('[data-fv-pop-cerrar]').forEach(function (b) {
    b.addEventListener('click', cerrar);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pop.hidden) cerrar();
  });

  // vuelta de Shopify tras dejar el correo: se muestra el código
  if (suscrito) {
    if (paso) paso.hidden = true;
    if (ok) ok.hidden = false;
    guardar(CLAVE, '1');
    abrir();
    return;
  }

  if (leer(CLAVE)) return;                 // ya lo vio antes
  if (/\/(cart|checkout)/.test(location.pathname)) return;

  var espera = (parseInt(pop.dataset.espera, 10) || 20) * 1000;
  var umbral = (parseInt(pop.dataset.scroll, 10) || 50) / 100;
  var lanzado = false;
  function estorbando() {
    // no interrumpir a quien tiene la cesta o el menu abiertos: si esta a punto
    // de pagar, un pop-up encima es la mejor forma de perder la venta
    var c = document.querySelector('.fv-cajon.is-abierto');
    var m = document.querySelector('.fv-menu.is-abierto');
    return !!(c || m);
  }

  function lanzar() {
    if (lanzado) return;
    if (estorbando()) { setTimeout(lanzar, 5000); return; }   // se reintenta luego
    lanzado = true;
    window.removeEventListener('scroll', porScroll);
    abrir();
  }
  var reloj = setTimeout(lanzar, espera);
  function porScroll() {
    var alto = document.documentElement.scrollHeight - window.innerHeight;
    if (alto > 0 && window.scrollY / alto >= umbral) { clearTimeout(reloj); lanzar(); }
  }
  window.addEventListener('scroll', porScroll, { passive: true });

  // copiar el código
  var btn = pop.querySelector('[data-fv-pop-copiar]');
  if (btn && navigator.clipboard) {
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(btn.dataset.codigo).then(function () {
        var t = btn.querySelector('[data-fv-pop-copiar-txt]');
        if (t) { t.textContent = 'Copiado'; setTimeout(function () { t.textContent = 'Copiar'; }, 2200); }
      });
    });
  }
})();

/* ---- copiar el código de descuento de la ficha ------------------------- */
(function () {
  'use strict';
  document.querySelectorAll('[data-fv-copiar-cod]').forEach(function (b) {
    b.addEventListener('click', function () {
      var cod = b.dataset.codigo || '';
      var fin = function () {
        var t = b.querySelector('[data-fv-copiar-txt]');
        if (!t) return;
        t.textContent = 'Copiado';
        setTimeout(function () { t.textContent = 'Copiar'; }, 2200);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(cod).then(fin).catch(fin);
      } else {
        var a = document.createElement('textarea');
        a.value = cod; document.body.appendChild(a); a.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(a); fin();
      }
    });
  });
})();

/* ==========================================================================
   LOTE INTERACTIVO
   Los descuentos por cantidad de la tienda saltan en la cesta; hasta entonces
   el cliente no los ve. Aqui se le enseña la cuenta hecha antes de decidir.
   Los porcentajes son los de los descuentos automaticos reales: 5/10/15.
   ========================================================================== */
(function () {
  'use strict';
  var caja = document.querySelector('[data-fv-lote-caja]');
  var raiz = document.querySelector('[data-fv-producto]');
  if (!caja || !raiz) return;

  var datos = raiz.querySelector('[data-fv-variantes]');
  var variantes;
  try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
  var vendibles = variantes.filter(function (v) { return v.available; });
  if (!vendibles.length) return;

  var tramos   = caja.querySelectorAll('[data-fv-tramo]');
  var unidades = caja.querySelector('[data-fv-lote-unidades]');
  var elAntes  = caja.querySelector('[data-fv-lote-antes]');
  var elTotal  = caja.querySelector('[data-fv-lote-total]');
  var elAhorro = caja.querySelector('[data-fv-lote-ahorro]');
  var boton    = caja.querySelector('[data-fv-lote-anadir]');
  var botonTx  = caja.querySelector('[data-fv-lote-anadir-txt]');
  var n = 1;

  function dinero(c) {
    return (c / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD')
    });
  }

  // La unidad 1 es la que se elige arriba con el selector normal de la ficha:
  // asi no hay dos sitios donde elegir lo mismo y contradecirse.
  function variantePrincipal() {
    var campo = raiz.querySelector('[data-fv-variante-id]');
    var id = campo && parseInt(campo.value, 10);
    var v = variantes.find(function (x) { return x.id === id; });
    return (v && v.available) ? v : vendibles[0];
  }

  function pct(cantidad) {
    if (cantidad >= 4) return 15;
    if (cantidad === 3) return 10;
    if (cantidad === 2) return 5;
    return 0;
  }

  function pintaUnidades() {
    var actual = variantePrincipal();
    var previas = {};
    unidades.querySelectorAll('select').forEach(function (s, i) { previas[i] = s.value; });

    unidades.innerHTML = '';
    if (n < 2) { unidades.hidden = true; return; }
    unidades.hidden = false;

    for (var i = 1; i < n; i++) {
      var fila = document.createElement('div');
      fila.className = 'fv-lote__unidad';

      var et = document.createElement('span');
      et.className = 'fv-lote__unidad-et';
      et.textContent = 'Piece ' + (i + 1);

      var sel = document.createElement('select');
      sel.className = 'fv-lote__sel';
      sel.setAttribute('aria-label', 'Choose piece ' + (i + 1));
      vendibles.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id;
        o.textContent = v.title;
        sel.appendChild(o);
      });
      sel.value = previas[i - 1] || actual.id;
      sel.addEventListener('change', pinta);

      fila.appendChild(et);
      fila.appendChild(sel);
      unidades.appendChild(fila);
    }
  }

  function lineas() {
    var out = [{ id: variantePrincipal().id, quantity: 1 }];
    unidades.querySelectorAll('select').forEach(function (s) {
      out.push({ id: parseInt(s.value, 10), quantity: 1 });
    });
    // pieza cruzada: solo si el cliente ha encendido el interruptor
    var cruz = document.querySelector('[data-fv-cruz]');
    var on = cruz && cruz.querySelector('[data-fv-cruz-on]');
    if (on && on.checked) out.push({ id: parseInt(cruz.dataset.variante, 10), quantity: 1 });
    return out;
  }

  function precioDe(id) {
    var v = variantes.find(function (x) { return x.id === id; });
    return v ? v.price : variantePrincipal().price;
  }

  function pinta() {
    var ls = lineas();
    var cruz = document.querySelector('[data-fv-cruz]');
    var on = cruz && cruz.querySelector('[data-fv-cruz-on]');
    var extra = (on && on.checked) ? parseInt(cruz.dataset.precio, 10) : 0;
    var bruto = ls.reduce(function (a, l) {
      return a + (l.id === (cruz && parseInt(cruz.dataset.variante, 10)) ? extra : precioDe(l.id)) * l.quantity;
    }, 0);
    var p = pct(ls.length);
    // Shopify reparte el descuento LINEA a LINEA y trunca cada parte; calcular
    // sobre el total y redondear da un centimo de diferencia, y entonces la
    // pantalla promete un precio y la cesta cobra otro.
    var desc = 0;
    for (var k = 0; k < ls.length; k++) {
      var pl = (cruz && ls[k].id === parseInt(cruz.dataset.variante, 10))
             ? extra : precioDe(ls[k].id);
      desc += Math.floor(pl * ls[k].quantity * p / 100);
    }
    var neto = bruto - desc;

    elTotal.textContent = dinero(neto);
    if (p > 0) {
      elAntes.textContent = dinero(bruto);
      elAntes.hidden = false;
      elAhorro.textContent = 'You save ' + dinero(bruto - neto);
      elAhorro.hidden = false;
    } else {
      elAntes.hidden = true;
      elAhorro.hidden = true;
    }

    // precio por pieza en cada tramo, para comparar de un vistazo
    var unidad = variantePrincipal().price;
    tramos.forEach(function (b) {
      var q = parseInt(b.dataset.fvTramo, 10);
      var ud = b.querySelector('[data-fv-tramo-ud]');
      if (ud) ud.textContent = dinero(Math.round(unidad * (100 - pct(q)) / 100)) + ' cada una';
    });
  }

  tramos.forEach(function (b) {
    b.addEventListener('click', function () {
      n = parseInt(b.dataset.fvTramo, 10);
      tramos.forEach(function (o) {
        var act = o === b;
        o.classList.toggle('es-activo', act);
        o.setAttribute('aria-checked', act ? 'true' : 'false');
      });
      pintaUnidades();
      pinta();
    });
  });

  // si cambia el color o la talla de arriba, el lote se recalcula
  raiz.addEventListener('change', function (e) {
    if (e.target.matches('input[type=radio]')) { pintaUnidades(); pinta(); }
  });

  // el interruptor de la pieza cruzada cuenta como una prenda mas: cambia el
  // total Y puede hacer saltar el siguiente tramo de descuento
  var cruzOn = document.querySelector('[data-fv-cruz-on]');
  if (cruzOn) cruzOn.addEventListener('change', pinta);

  boton.addEventListener('click', function () {
    boton.disabled = true;
    var antes = botonTx.textContent;
    botonTx.textContent = 'Añadiendo…';

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lineas() })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return fetch('?sections=fv-cesta'); })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var sec = document.getElementById('shopify-section-fv-cesta');
        if (d['fv-cesta'] && sec) sec.outerHTML = d['fv-cesta'];
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (c) {
        var b = document.querySelector('[data-fv-cesta-n]');
        if (b) b.textContent = c.item_count;
        if (window.fvCesta) window.fvCesta(true);
      })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { boton.disabled = false; botonTx.textContent = antes; });
  });

  // El formulario trae su propio boton de anadir. Con el lote funcionando
  // habria dos "Añadir a la cesta" seguidos diciendo cosas distintas. Se esconde
  // aqui, desde JS, para que quien no tenga JS siga pudiendo comprar.
  var acc = document.querySelector('[data-fv-acc]');
  if (acc) acc.classList.add('es-solo-cesta');

  pintaUnidades();
  pinta();
})();

/* ---- proceso de envio: la linea se dibuja al entrar en pantalla ---------- */
(function () {
  'use strict';
  var sec = document.querySelector('[data-fv-envio]');
  if (!sec) return;
  var pasos = sec.querySelectorAll('.fv-envio__paso');
  if (!pasos.length) return;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (quieto || !('IntersectionObserver' in window)) return;   // se queda visible

  // Los pasos solo se esconden si de verdad vamos a animarlos. Si el JS no
  // llega a correr, o el observador no dispara nunca, se ven igual: nada de
  // dejar una seccion entera en blanco por una animacion.
  sec.classList.add('es-animable');

  function revelar() {
    sec.classList.add('es-visible');
    pasos.forEach(function (p, i) {
      setTimeout(function () { p.classList.add('es-visible'); }, 140 * i);
    });
  }

  // umbral 0: la seccion mide mas que muchas pantallas y con un umbral alto
  // el ratio no se alcanzaria nunca en una ventana baja
  var obs = new IntersectionObserver(function (ents) {
    ents.forEach(function (e) {
      if (!e.isIntersecting) return;
      revelar();
      obs.disconnect();
    });
  }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
  obs.observe(sec);

  // red de seguridad: si en 4 s no ha disparado (ventana de altura 0, pestana
  // en segundo plano, lo que sea), se enseña igual
  setTimeout(function () {
    if (!sec.classList.contains('es-visible')) { revelar(); obs.disconnect(); }
  }, 4000);
})();

/* ---- parallax de la portada -------------------------------------------
   Cada capa lleva su factor en data-fv-capa. El puntero se persigue con
   retardo para que el movimiento sea liquido. Se apaga en tactil (no hay
   puntero que seguir) y con prefers-reduced-motion.                        */
(function () {
  'use strict';
  var hero = document.querySelector('[data-fv-hero]');
  if (!hero) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;

  var capas = hero.querySelectorAll('[data-fv-capa]');
  if (!capas.length) return;

  var dx = 0, dy = 0, sx = 0, sy = 0, pedido = false;

  hero.addEventListener('pointermove', function (e) {
    var r = hero.getBoundingClientRect();
    dx = (e.clientX - r.left) / r.width  - 0.5;
    dy = (e.clientY - r.top)  / r.height - 0.5;
    if (!pedido) { pedido = true; requestAnimationFrame(mover); }
  }, { passive: true });

  hero.addEventListener('pointerleave', function () {
    dx = 0; dy = 0;
    if (!pedido) { pedido = true; requestAnimationFrame(mover); }
  }, { passive: true });

  function mover() {
    sx += (dx - sx) * 0.08;
    sy += (dy - sy) * 0.08;
    capas.forEach(function (c) {
      var f = parseFloat(c.dataset.fvCapa) || 0;
      var x = -sx * 34 * f, y = -sy * 22 * f;
      var z = f > 0.5 ? ' rotateY(' + (sx * 3.2) + 'deg) rotateX(' + (-sy * 2.4) + 'deg)' : '';
      c.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0)' +
                          (f < 0.5 ? ' scale(1.08)' : '') + z;
    });
    if (Math.abs(dx - sx) > 0.001 || Math.abs(dy - sy) > 0.001) {
      requestAnimationFrame(mover);
    } else { pedido = false; }
  }
})();

/* ==========================================================================
   ORDEN EN LA COLECCION
   Se reordena en el navegador: el catalogo es pequeno y recargar la pagina por
   cada cambio de orden se nota mucho mas que mover unas tarjetas. "Featured" es
   el orden curado que viene del servidor, por eso cada tarjeta guarda su
   posicion original: sin eso, no se podria volver a el.
   ========================================================================== */
(function () {
  'use strict';
  var sel = document.querySelector('[data-fv-orden]');
  var rejilla = document.querySelector('[data-fv-muro]') || document.querySelector('[data-fv-rejilla]');
  if (!sel || !rejilla) return;

  var items = Array.prototype.slice.call(rejilla.querySelectorAll('[data-fv-pieza],[data-fv-item]'));
  if (items.length < 2) return;

  var criterios = {
    'curado':      function (a, b) { return +a.dataset.pos - +b.dataset.pos; },
    'precio-asc':  function (a, b) { return +a.dataset.precio - +b.dataset.precio; },
    'precio-desc': function (a, b) { return +b.dataset.precio - +a.dataset.precio; },
    'az':          function (a, b) { return a.dataset.nombre.localeCompare(b.dataset.nombre, 'en'); }
  };

  sel.addEventListener('change', function () {
    var cmp = criterios[sel.value] || criterios.curado;
    var ordenados = items.slice().sort(cmp);

    // se apagan un momento para que el salto no sea seco
    rejilla.classList.add('es-ordenando');
    setTimeout(function () {
      var frag = document.createDocumentFragment();
      ordenados.forEach(function (el) { frag.appendChild(el); });
      rejilla.appendChild(frag);
      rejilla.classList.remove('es-ordenando');
    }, 180);
  });
})();

/* ==========================================================================
   SCROLL-SHIFT DEL MURO
   Cada columna avanza a una velocidad ligeramente distinta al hacer scroll. El
   muro deja de leerse como una cuadrícula rígida y se mueve como tela.
   El desplazamiento es pequeño (24 px como mucho) a proposito: mas que eso
   descuadra las filas y se lee como un fallo, no como un efecto.

   Se apaga en movil (dos columnas, no hay sitio), con prefers-reduced-motion,
   y cuando el muro no esta en pantalla. Si no arranca, el muro se ve plano y
   perfectamente usable: el efecto nunca es condicion para ver el producto.
   ========================================================================== */
(function () {
  'use strict';
  var muro = document.querySelector('[data-fv-muro]');
  if (!muro) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var piezas = Array.prototype.slice.call(muro.querySelectorAll('[data-fv-pieza]'));
  if (piezas.length < 4) return;

  // cuanto se adelanta o retrasa cada columna. La suma es cero: el muro no se
  // desplaza en conjunto, solo se descompone.
  var FACTOR = [0.028, -0.018, 0.014, -0.024];
  var MAX = 24;
  var activo = false, pedido = false;

  function anchoOk() { return window.innerWidth > 700; }

  function pintar() {
    pedido = false;
    if (!activo || !anchoOk()) return;
    var y = window.scrollY;
    var base = muro.offsetTop;
    for (var i = 0; i < piezas.length; i++) {
      var f = FACTOR[+piezas[i].dataset.col % 4];
      var d = (y - base) * f;
      if (d > MAX) d = MAX; else if (d < -MAX) d = -MAX;
      piezas[i].style.transform = 'translate3d(0,' + d.toFixed(2) + 'px,0)';
    }
  }

  function alScroll() {
    if (!pedido) { pedido = true; requestAnimationFrame(pintar); }
  }

  function limpiar() {
    for (var i = 0; i < piezas.length; i++) piezas[i].style.transform = '';
  }

  window.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (!anchoOk()) limpiar(); else alScroll();
  }, { passive: true });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      activo = es[0].isIntersecting;
      if (activo) alScroll();
    }, { rootMargin: '200px' }).observe(muro);
  } else {
    activo = true;
  }
  alScroll();
})();

/* ---- entrega estimada: 4-8 laborables desde hoy (politica de envios) ----- */
(function () {
  'use strict';
  var caja = document.querySelector('[data-fv-entrega]');
  var txt  = document.querySelector('[data-fv-entrega-txt]');
  if (!caja || !txt) return;

  function laborables(n) {
    var d = new Date();
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }
  function fecha(d) {
    return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '');
  }
  try {
    txt.textContent = 'Pídelo hoy y llega entre el ' + fecha(laborables(4)) + ' y el ' + fecha(laborables(8)) + '.';
    caja.hidden = false;
  } catch (e) { /* sin fechas no pasa nada: la politica de envios ya lo dice */ }
})();

/* ---- barra de compra pegajosa -------------------------------------------
   Cuando el boton de anadir queda por encima de la pantalla, sale una barra
   abajo con la foto, el precio y un boton que pulsa el de verdad. */
(function () {
  'use strict';
  var barra = document.querySelector('[data-fv-compra]');
  if (!barra || !('IntersectionObserver' in window)) return;
  var ancla = document.querySelector('[data-fv-lote-anadir]') || document.querySelector('[data-fv-anadir]');
  if (!ancla) return;

  var btn    = barra.querySelector('[data-fv-compra-anadir]');
  var precio = barra.querySelector('[data-fv-compra-precio]');
  var img    = barra.querySelector('[data-fv-compra-img]');
  var fuente = document.querySelector('[data-fv-precio]');

  btn.addEventListener('click', function () { ancla.click(); });

  // Reflejo de precio, foto y disponibilidad al cambiar de variante. El rAF
  // deja que los manejadores del formulario pinten primero.
  document.addEventListener('change', function () {
    requestAnimationFrame(function () {
      if (fuente) precio.textContent = fuente.textContent.trim();
      var act = document.querySelector('[data-fv-gal] .fv-gal__foto.es-activa img');
      if (act && act.currentSrc) img.src = act.currentSrc;
      btn.disabled = ancla.disabled && ancla.textContent.indexOf('Añadiendo') === -1;
    });
  });

  barra.hidden = false;                       // visible para el navegador; fuera de pantalla por CSS
  new IntersectionObserver(function (es) {
    var e = es[0];
    barra.classList.toggle('es-visible', !e.isIntersecting && e.boundingClientRect.bottom < 0);
  }, { threshold: 0 }).observe(ancla);
})();

/* ---- lupa: la foto de la galeria a pantalla completa --------------------- */
(function () {
  'use strict';
  var lupa = document.querySelector('[data-fv-lupa]');
  var gal  = document.querySelector('[data-fv-gal]');
  if (!lupa || !gal) return;

  var img  = lupa.querySelector('[data-fv-lupa-img]');
  var idx  = 0;

  function fotos() { return gal.querySelectorAll('.fv-gal__foto img'); }
  function grande(f) {
    var u = f.currentSrc || f.src;
    return u.replace(/([?&]width=)\d+/, '$11800');
  }
  function pinta() {
    var fs = fotos();
    if (!fs.length) return;
    idx = (idx + fs.length) % fs.length;
    img.src = grande(fs[idx]);
    img.alt = fs[idx].alt || '';
  }
  function abre(i) {
    idx = i; pinta();
    lupa.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', teclas);
  }
  function cierra() {
    lupa.hidden = true;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', teclas);
  }
  function teclas(ev) {
    if (ev.key === 'Escape') cierra();
    else if (ev.key === 'ArrowLeft')  { idx--; pinta(); }
    else if (ev.key === 'ArrowRight') { idx++; pinta(); }
  }

  gal.addEventListener('click', function (ev) {
    var f = ev.target.closest('.fv-gal__foto img');
    if (!f) return;
    abre(Array.prototype.indexOf.call(fotos(), f));
  });
  lupa.querySelector('[data-fv-lupa-x]').addEventListener('click', cierra);
  lupa.querySelector('[data-fv-lupa-ant]').addEventListener('click', function () { idx--; pinta(); });
  lupa.querySelector('[data-fv-lupa-sig]').addEventListener('click', function () { idx++; pinta(); });
  lupa.addEventListener('click', function (ev) { if (ev.target === lupa) cierra(); });
})();

/* ---- vistos recientemente: localStorage, sin servidor -------------------- */
(function () {
  'use strict';
  var sec   = document.querySelector('[data-fv-vistos]');
  var datos = document.querySelector('[data-fv-visto-actual]');
  if (!sec || !datos) return;

  var actual;
  try { actual = JSON.parse(datos.textContent); } catch (e) { return; }
  if (!actual || !actual.handle) return;

  var CLAVE = 'fv-vistos', lista = [];
  try { lista = JSON.parse(localStorage.getItem(CLAVE) || '[]'); } catch (e) {}
  if (!Array.isArray(lista)) lista = [];
  var otros = lista.filter(function (x) { return x && x.handle && x.handle !== actual.handle; });

  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  }
  if (otros.length) {
    var h = '';
    otros.slice(0, 8).forEach(function (x) {
      h += '<a class="fv-visto" href="' + esc(x.url) + '">' +
             '<img loading="lazy" src="' + esc(x.img) + '" alt="" width="500" height="625">' +
             '<span class="fv-visto__t">' + esc(x.titulo) + '</span>' +
             '<span class="fv-visto__p">' + esc(x.precio) + '</span>' +
           '</a>';
    });
    sec.querySelector('[data-fv-vistos-pista]').innerHTML = h;
    sec.hidden = false;
  }
  try { localStorage.setItem(CLAVE, JSON.stringify([actual].concat(otros).slice(0, 9))); } catch (e) {}
})();

/* ---- cierre del dia -----------------------------------------------------
   La estimacion de entrega se calcula con la fecha de hoy, asi que a
   medianoche cambia de verdad. Solo avisamos cuando aprieta: ultimas 6 h. */
(function () {
  'use strict';
  var ancla = document.querySelector('[data-fv-entrega]');
  if (!ancla) return;
  var aviso = null;
  function pinta() {
    var ahora = new Date();
    var media = new Date(ahora);
    media.setHours(24, 0, 0, 0);
    var min = Math.floor((media - ahora) / 60000);
    if (min > 360 || min <= 0) {
      if (aviso) { aviso.remove(); aviso = null; }
      return;
    }
    if (!aviso) {
      aviso = document.createElement('span');
      aviso.className = 'fv-cierre';
      ancla.appendChild(aviso);
    }
    var h = Math.floor(min / 60), m = min % 60;
    aviso.textContent = 'Quedan ' + (h > 0 ? h + ' h ' : '') + m + ' min para pedir con esta fecha.';
  }
  pinta();
  setInterval(pinta, 30000);
})();
